import React from 'react'
import { Link } from 'gatsby'
import Heading from 'shared/ui/Heading'
import Icon from 'shared/ui/Icon'
import './BlogWorkshopMessage.scss'

export default function BlogWorkshopMessage() {
  return (
    <section className="blog-workshop-message spacing align-center">
      <Heading size={3}>Did you like this content?</Heading>
      <p>
        We have regularly scheduled public workshops for beginner though advanced topics. All
        workshops are remote and your company might help you pay for it, just ask! We also conduct
        corporate trainings if you need more of a personalized experience.
      </p>
      <Link to="/public-workshops" className="button button-small icon-text">
        <Icon name="arrow-right" size={2} color="lightBlue" />
        <span>Attend a Public Workshop</span>
      </Link>
    </section>
  )
}
